import { render, staticRenderFns } from "./DeleteChannel.html?vue&type=template&id=53c71286&scoped=true&"
import script from "./DeleteChannel.js?vue&type=script&lang=js&"
export * from "./DeleteChannel.js?vue&type=script&lang=js&"
import style0 from "./DeleteChannel.scss?vue&type=style&index=0&id=53c71286&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c71286",
  null
  
)

export default component.exports